(function () {
  const SELECTOR = 'div#CollectionProductGrid .product-item__text';

  function equalizeHeights() {
    if (!document.body.classList.contains('template-collection')) return;

    const items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    // Reset first so we measure natural height (needed on resize / re-runs)
    items.forEach(el => { el.style.height = 'auto'; });

    let max = 0;
    items.forEach(el => {
      max = Math.max(max, el.getBoundingClientRect().height);
    });

    items.forEach(el => { el.style.height = max + 'px'; });
  }

  document.addEventListener('DOMContentLoaded', equalizeHeights);
  window.addEventListener('load', equalizeHeights); // after images/fonts settle

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeHeights, 150);
  });

  // Re-run when products get injected (filters, pagination, infinite scroll)
  let mutationTimer;
  new MutationObserver(() => {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(equalizeHeights, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();


(function () {
  const SELECTOR = 'product-recommendations .product-item__text';

  function equalizeHeights() {
    if (!document.body.classList.contains('template-product')) return;

    const items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    // Reset first so we measure natural height (needed on resize / re-runs)
    items.forEach(el => { el.style.height = 'auto'; });

    let max = 0;
    items.forEach(el => {
      max = Math.max(max, el.getBoundingClientRect().height);
    });

    items.forEach(el => { el.style.height = max + 'px'; });
  }

  document.addEventListener('DOMContentLoaded', equalizeHeights);
  window.addEventListener('load', equalizeHeights); // after images/fonts settle

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeHeights, 150);
  });

  // Re-run when products get injected (filters, pagination, infinite scroll)
  let mutationTimer;
  new MutationObserver(() => {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(equalizeHeights, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();


function equalizeProductTitles(scope = document) {
  scope.querySelectorAll('[data-js-product-item]').forEach(item => {
    item.querySelectorAll('.product-item__title').forEach(t => {
      t.style.display = 'block';
      t.style.height = 'auto';
    });
  });

  scope.querySelectorAll('.collection.grid').forEach(grid => {
    const titles = [...grid.querySelectorAll('.product-item__title')];
    if (!titles.length) return;
    const max = Math.max(...titles.map(t => t.offsetHeight));
    titles.forEach(t => (t.style.height = max + 'px'));
  });
}

// run once fonts + images are settled
window.addEventListener('load', () => equalizeProductTitles());
document.fonts?.ready.then(() => equalizeProductTitles());

// re-run on resize (debounced)
let rz;
window.addEventListener('resize', () => {
  clearTimeout(rz);
  rz = setTimeout(() => equalizeProductTitles(), 150);
});


function equalizeProductItems() {
  var sections = document.querySelectorAll('[data-shopify-editor-section*=\'"type":"featured-collection"\']');
  sections.forEach(function(section) {
    ['product-item__price', 'product-item__title'].forEach(function(cls) {
      var selector = cls === 'product-item__title' ? 'a.product-item__title' : '.' + cls;
      var els = section.querySelectorAll(selector);
      els.forEach(function(el) { el.style.height = ''; });
      var max = 0;
      els.forEach(function(el) { if (el.offsetHeight > max) max = el.offsetHeight; });
      if (max > 0) els.forEach(function(el) { el.style.height = max + 'px'; });
    });
  });
}

if (document.readyState === 'complete') {
  equalizeProductItems();
} else {
  window.addEventListener('load', equalizeProductItems);
}
window.addEventListener('resize', equalizeProductItems);